//Updated "Stop prohibited checkouts (only with free washing bag)" script

//HELPER
        function waitForElement(selector, callback) {
          const element = document.querySelector(selector);
          if (element) {
            callback(element);
          } else {
            setTimeout(() => waitForElement(selector, callback), 100); // Retry after 100ms
          } 
        }

waitForElement('button#checkout', (element) => {
//conversoin factor!
let factor = Shopify.currency.rate;

//Threshold, pounds to local crcy.
let gift_threshold = parseFloat((factor * 4900).toFixed(0));

  const targetVariantId = "48392327856393"; // The variant ID to remove
  const subtotalSelector = ".cart__footer .totals__total-value";
  const cartFooterSelector = ".cart__footer .js-contents";

  // Function to check subtotal and remove item if needed
  function checkSubtotalAndRemove() {
    const subtotalEl = document.querySelector(subtotalSelector);
    if (!subtotalEl) return;

    const subtotal = parseDisplayToCents(subtotalEl.textContent);

    console.log("Checking subtotal:", subtotal);

  //check, amt in cents.
    if (subtotal < gift_threshold) {
      // Find cart remove buttons
      const removeButtons = document.querySelectorAll("cart-remove-button");
      if (!removeButtons) return;

      removeButtons.forEach((btn) => {
        //find the relevant "bad" item.
        const link = btn.querySelector("a[href*='id=" + targetVariantId + "']");

        if (!link) return;
        if (link) {
          console.log("Clicking remove button for variant:", targetVariantId);
          link.click(); // trigger removal
        }
      });
    }
  }

  // --- Run once on page load ---
  checkSubtotalAndRemove();

   // --- Set up observer on cart footer ---
  const cartFooter = document.querySelector(cartFooterSelector);
  if (cartFooter) {
    const observer = new MutationObserver(() => {
      setTimeout(checkSubtotalAndRemove, 750);
    });

    observer.observe(cartFooter, {
      childList: true,   // detect added/removed nodes
      characterData: true, // detect text changes
      subtree: true,      // watch all children
    });
  } else {
    console.warn("Cart footer element not found for observation!");
  }


  //helper only!
  function parseDisplayToCents(text) {
  if (!text) return 0;

  // Remove any non-digit, non-decimal characters (keep . or ,)
  let cleaned = text.replace(/[^0-9.,]/g, '').trim();

  if (!cleaned) return 0;

  // Detect decimal separator
  let parts;
  if (cleaned.includes(',')) {
    // Assume comma is decimal separator if it occurs after a dot or no dot
    if (cleaned.includes('.') && cleaned.indexOf('.') < cleaned.indexOf(',')) {
      // format like "1.234,56" -> remove dots, comma is decimal
      cleaned = cleaned.replace(/\./g, '');
    }
    parts = cleaned.split(',');
  } else {
    // Only dot decimal or integer
    parts = cleaned.split('.');
  }

  let units = parseInt(parts[0].replace(/[^0-9]/g, ''), 10) || 0;
  let decimals = parseInt((parts[1] || '0').padEnd(2, '0').slice(0, 2), 10) || 0;

  return units * 100 + decimals;
}

});